<script>
	import { onMount, beforeUpdate, afterUpdate } from 'svelte'
	import DropDown from './dropdown.svelte'
	import { positionStore, departmentStore } from "./store.js"

	import { gsap } from 'gsap'
	import { ScrollTrigger } from 'gsap/ScrollTrigger'
	gsap.registerPlugin(ScrollTrigger)
	
   // const urlParams = new URLSearchParams(window.location.href.split('?')[1]);
	let results, team, departments, positions, loadPosition, loadDepartment
	results = positions = departments = team = []
	let isFrench = window.location.href.includes('/fr/')
	let department, filteredTeam, spac = window.$('body').hasClass('page-template-spac')

	let filterByLabel = filterBy
	let allTeamLabel = allTeam
	let noOneFoundLabel = noOneFound
	let loadingLabel = loading
	let learnMoreLabel = learnMore
	let readMoreLabel = readMore
	let errorLabel = error
	
	positionStore.subscribe(value => {
		if(value) {
			position = value;
		}
	});
	// loadPosition = urlParams.get('position')
	departmentStore.subscribe(value => {
		if(value) {
			department = value;
		}
	});
	// loadDepartment = urlParams.get('department')

	let spacOrder = [
		
	]
	$: {
		if(
			spac && department && department.slug === null //all
		){
			filteredTeam = team
				.filter((tm) => {
					if (!department || !department.slug) return true
					if( !tm.departments ) return false
					return tm.departments.map(d => d.name).includes(department.name)
				})
				.sort((a, b) => { //paul desmaris III
					if(a['name'].split(" ").length < 2) { console.log(a['name']); return -1; }
					if(b['name'].split(" ").length < 2) { console.log(b['name']); return 1; }
					return a['name'].split(" ")[1] >= b['name'].split(" ")[1] ? 1 : -1
				})
		} else {
			filteredTeam = team
				.filter((tm) => {
					if (!department || !department.slug) return true
					if( !tm.departments ) return false
					return tm.departments.map(d => d.name).includes(department.name)
				})
				.sort((a, b) => { //paul desmaris III
					if(a['name'].split(" ").length < 2) { console.log(a['name']); return -1; }
					if(b['name'].split(" ").length < 2) { console.log(b['name']); return 1; }
					return a['name'].split(" ")[1] >= b['name'].split(" ")[1] ? 1 : -1
				})
		}
	}

   $: {
      let dep_slug = ''
		// console.log(departmentStore.value)
		if(department && department.slug) {// TODO clear
			dep_slug = `?department=${department.slug}`
      	history.replaceState({}, '', dep_slug)
			// console.log(sessionStorage)
			sessionStorage.setItem('selectedTeam', JSON.stringify(department))
			// console.log(JSON.parse(sessionStorage.getItem('selectedTeam')))
		} 
		else if(departments.length) {
			history.replaceState({}, '', location.href.split('?')[0])
		}
   }

	results = getTeam()
	async function getTeam() {
		let frUrl = isFrench ? '/fr' : ''
		let res = await fetch(`${frUrl}/wp-json/theme/v1/get-team?spac=${spac}`) //TODO transient
		const data = await res.json()
		
		if (res.ok) {
			// console.log(data)
			data.sort((a, b) => { //paul desmaris III
				if(a['name'].split(" ").length < 2) { console.log(a['name']); return -1; }
				if(b['name'].split(" ").length < 2) { console.log(b['name']); return 1; }
				return a['name'].split(" ")[1] >= b['name'].split(" ")[1] ? 1 : -1
			})
			// console.log(data)
			team = data
			let positionSet = []
			let departmentSet = []
			team.filter(tm => {
				if (!tm.departments) return false;
				
				for(let dep of tm.departments) {
					if(!departmentSet.includes(dep.term_id)) {
						departmentSet.push(dep.term_id)
						departments.push(dep)
						return true
					}
				}
				departments.sort((a, b) => {
					return a.name > b.name ? 1:-1
				})
				// if(spac) {
				// 	departments.filter((d) => {
				// 		console.log(d)
				// 		return true
				// 	})
				// }
			})
			let sessionObj, sessionSlug
			console.log(sessionStorage)
			if(sessionStorage.getItem('selectedTeam')){
				sessionObj = JSON.parse(sessionStorage.getItem('selectedTeam'))
				if(Object.keys(sessionObj).includes('slug')) {
					sessionSlug = sessionObj['slug']
				}
			}
			if(sessionSlug) {
				departmentStore.set(departments.filter(dep => dep.slug.includes(sessionSlug))[0])
			} else {
				// if(spac) {
				// 	departmentStore.set(departments.filter(item => item.term_id == '46')[0])
				// } else {
				
				if(isFrench) { //assumes existence/unchanged
					departmentStore.set(departments.filter(item => item.term_id == '75')[0])
				} else {
					departmentStore.set(departments.filter(item => item.term_id == '49')[0])
				}
				
				// }
			}
			// positions = team.filter(tm => {
			// 	if (!tm.position) return false;
			// 	if(!positionSet.includes(tm.position)) {
			// 		positionSet.push(tm.position)
			// 		return true
			// 	}
			// 	return false
			// }).map((tm) => {
			// 	return {"slug": tm.position.toLowerCase().replace(/\s+/g, '-').replace(/,/g, ''), "name": tm.position }}).sort((a,b) => a.slug > b.slug ? 1:-1)
			// if(loadPosition) {
			// 	positionStore.set(positions.filter(pos => pos.slug.includes(loadPosition))[0])
			// }
		} else {
			console.log(data)
			throw new Error(data)
		}
	}

	$: {
		if(filteredTeam.length) {
			gsap.set('.team-member', {autoAlpha: 0, y: 32 })
			setTimeout(() => {
				gsap.set('.team-member', {autoAlpha: 0, y: 32 })
				Array.from(document.querySelectorAll('.team-member')).forEach( (el, idx) => {
					gsap.to(el, {scrollTrigger: { trigger: el, start: 'top 90%' }, delay: 0.1*(idx%4), y: 0, autoAlpha: 1, duration: 0.35 })
				})
			}, 200)
		}
	}
</script>

<div class="team-wrap">
	<!-- {#if !spac } -->
	<div class="team-filters filter-bar d-flex">
		<p class="filter-label"><strong>{filterByLabel}:</strong></p>
		{#if departments.length}
			<DropDown store={departmentStore} allLabel={allTeamLabel} items={departments} isTeam={true} spac={spac}/>
		{/if}
	</div>
	<!-- {/if} -->
	<div class="team-grid grid-four">
		{#await results}
			<!-- <p>{loadingLabel}...</p> -->
		{:then}
			{#if filteredTeam.length}
				{#each filteredTeam as member}
					<div class="team-member grid-item">
						<a href={member.url} class="fillall"><span class="sr-only">{learnMoreLabel} about {member.name}. visit {member.url}</span></a>
						<div
							class="tm-image"
							style="{member.img ? `background-image:url(${member.img})`:''}"
							aria-hidden="true"
						></div>
						<div class="tm-content">
							<h3>{member.name}</h3>
							<p>{member.position}</p>
							<a href={member.url}>
								<span class="sr-only">{readMoreLabel}</span>
								<svg
									width="34"
									height="34"
									viewBox="0 0 34 34"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M27.4341 17.7932L20.3791 24.8766C20.1524 25.1032 19.8691 25.2166 19.5857 25.2166C19.3024 25.2166 19.0191 25.1032 18.7924 24.8766C18.3391 24.4232 18.3391 23.7149 18.7924 23.2616L23.9207 18.1049H7.37406C6.75072 18.1049 6.24072 17.5949 6.24072 16.9716C6.24072 16.3482 6.75072 15.8382 7.37406 15.8382H23.9207L18.7924 10.6816C18.3391 10.2282 18.3391 9.5199 18.7924 9.06656C19.2457 8.61323 19.9541 8.61323 20.4074 9.06656L27.4624 16.1499C27.8874 16.6316 27.8874 17.3682 27.4341 17.7932Z"
										fill="#A8353A"
									/>
								</svg>
							</a>
						</div>
					</div>
				{/each}
			{:else}
				<p>{noOneFoundLabel}...</p>
			{/if}
		{:catch error}
			<p style="color: red" data-error={error.toString()}>{errorLabel}</p>
		{/await}
	</div>
</div>
